import { PageHeader } from "antd";
import DashboardProvider from "../contexts/dashboard-context";

export function Dashboard2() {
  return (
    <PageHeader ghost>
      <DashboardProvider.DashboardIFrame />
    </PageHeader>
  );
}
